import React, { useEffect, useState } from "react";
import axios from "axios";
import RichTextEditor from "react-rte";
import { useNavigate } from "react-router-dom";
import QuickReadPreview from "../popup/quickReadPreview/QuickReadPreview"; // Or create BlogPreview if needed

function CreateBlog() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [disableButton, setDisableButton] = useState(false);

  const [blogId, setBlogId] = useState('')
  const [isActive, setIsActive] = useState(false)
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [category, setCategory] = useState("");
  const [images, setImages] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [editorValue, setEditorValue] = useState(RichTextEditor.createEmptyValue());

  const handleChange = (value) => setEditorValue(value);

  const handlePreviewClick = (e) => {
    e.preventDefault();
    setPreviewModal(true);
  };

  const handleNotificationError = () => {
    if (errorMessage) setErrorMessage("");
  };


  const uploadCoverImage = async ({ target }) => {
    setDisableButton(true);
    handleNotificationError();
    const files = target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("images", files[i]);
    }
    try {
      const res = await axios.post(
        "https://qrs.btartisticyoga.com/magicFood/uploadImageToAWS/", // <-- Change to your blog cover image API
        formData
      );
      setCoverImage(res.data.urls[0]);
    } catch (err) {
      console.error(err);
    }
    setDisableButton(false);
  };


// const uploadCoverImage = async ({ target }) => {
//     try {
//       setDisableButton(true);
//       handleNotificationError();
  
//       const files = target.files;
//       console.log("Selected files:", files);
  
//       const uploadedUrls = [];
  
//       // Loop through files and upload each
//       for (let i = 0; i < files.length; i++) {
//         const file = files[i];
  
//         // Prepare FormData
//         const formData = new FormData();
//         formData.append("image", file); // "image" must match upload.single("image") in backend
  
//         // Send to backend
//         const res = await axios.post(
//           "http://127.0.0.1:5001/btay-project-1551779459124/us-central1/AY/uploadImage",
//           formData,
//           {
//             headers: { "Content-Type": "multipart/form-data" },
//           }
//         );
  
//         console.log("Uploaded image URL:", res.data.url);
//         uploadedUrls.push(res.data.url);
//       }
  
//       // Use first uploaded image as cover image
//       if (uploadedUrls.length > 0) {
//         setCoverImage(uploadedUrls[0]);
//       }
  
//       setDisableButton(false);
//     } catch (err) {
//       console.error("Upload failed:", err);
//       setDisableButton(false);
//     }
//   };
  



  const submitNewBlog = async (e) => {
    e.preventDefault();
    
    const obj = {
      id:blogId,
      title,
      subtitle,
      category,
      metaDescription,
      isActive,
      description: editorValue.toString("html"),
    //   content: editorValue.toString("html"),
    //   imageAssets: images,
        coverImage: coverImage,
    };
    console.log(obj)
    setDisableButton(true);
    try {
      const response = await fetch("https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/create/blog", {
      // const response = await fetch("http://127.0.0.1:5001/btay-project-1551779459124/us-central1/AY/create/blog", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
      });
      await response.json();
      setTitle("");
      setImages(null);
      setCategory("");
      setSubtitle("");
      setCoverImage(null);
      alert("Blog added successfully");
      navigate("/home");
    } catch (error) {
      console.error(error);
      alert("Something went wrong!!");
    }
    setDisableButton(false);
  };

  useEffect(() => {
    if(!title || editorValue.toString("html") === "<p><br></p>"){
        setDisableButton(true)
    }
    else{
        setDisableButton(false)
    }
  }, [title, editorValue])
  

  return (
    <div className="Apps">
      <div className="breadcrumbcontainer">
        <div className="breadcrumb-nav">
          <img src="/assets/rightchevron.png" alt="" />
          <span>Post Blog</span>
        </div>
      </div>
      <form className="quickread_from" onSubmit={submitNewBlog}>
      <div className="mb-3">
          <label htmlFor="id" className="form-label">Id<span className="required">*</span></label>
          <input
            type="text"
            className="form-control"
            id="blogId"
            value={blogId}
            onChange={e => { handleNotificationError(); setBlogId(e.target.value); }}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title<span className="required">*</span></label>
          <input
            type="text"
            className="form-control"
            id="title"
            value={title}
            onChange={e => { handleNotificationError(); setTitle(e.target.value); }}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="subtitle" className="form-label">Subtitle</label>
          <input
            type="text"
            className="form-control"
            id="subtitle"
            value={subtitle}
            onChange={e => { handleNotificationError(); setSubtitle(e.target.value); }}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="subtitle" className="form-label">Meta Description</label>
          <input
            type="text"
            className="form-control"
            id="metaDescription"
            value={metaDescription}
            onChange={e => { handleNotificationError(); setMetaDescription(e.target.value); }}
          />
        </div>

        <div className="mb-4">
          <label htmlFor="category" className="form-label">Category</label>
          <input
            type="text"
            className="form-control"
            id="category"
            value={category}
            onChange={e => { handleNotificationError(); setCategory(e.target.value); }}
          />
        </div>

        <div className="mb-3 mt-2 d-flex gap-2 align-items-center">
          <input
            type="checkbox"
            id="isActive"
            checked={isActive}
            onChange={(e) => {
              handleNotificationError();
              setIsActive(e.target.checked); // 👈 use checked instead of value
            }}
          />
          <label htmlFor="isActive" className="form-label">Is Blog Active</label>
        </div>

        <div className="mb-3">
          <label htmlFor="coverImage" className="form-label">Thumbnail Image <span className="required">*</span></label>
          <input
            type="file"
            className="form-control"
            id="coverImage"
            onChange={uploadCoverImage}
          />
        </div>
        <p style={{ marginBottom: "0rem", fontSize: "14px" }} className="Login_error">
          Note: Thumbnail Image Size should be between 120KB to 200KB.
        </p>
        
        <div className="mb-3 mt-2">
          <label htmlFor="desc" className="form-label">Content<span className="required">*</span></label>
          <RichTextEditor className="rich-text-editor" toolbarClassName="editor-toolbar" value={editorValue} onChange={handleChange} />
        </div>
        <p className="Login_error">{errorMessage}</p>
        {editorValue.toString("html") !== "<p><br></p>" && title && images && (
          <button className="quickRead__previewButton" onClick={handlePreviewClick}>
            Preview
          </button>
        )}
        <input
          disabled={disableButton}
          className="submitBtn"
          type="submit"
          value="Submit"
        />
      </form>
      <QuickReadPreview
        show={previewModal}
        onHide={() => setPreviewModal(false)}
        desc={editorValue.toString("html")}
        images={images}
        title={title}
      />
    </div>
  );
}

export default CreateBlog;